var map = {
	"./bns-white.png": "182d",
	"./bns-white.svg": "831b",
	"./bns.svg": "c168",
	"./icons/box.png": "0a2e",
	"./icons/box.svg": "bb19",
	"./icons/box2.svg": "8f8a",
	"./icons/clipboard.svg": "4247",
	"./icons/group.svg": "51a3",
	"./images/1.jpg": "98a8",
	"./images/2.jpg": "593c",
	"./images/3.jpg": "6800",
	"./images/fc-tip.png": "42b7",
	"./images/foldgaz.jpg": "b7de",
	"./images/gazszallitas.jpg": "9388",
	"./images/gazszallitas2.jpg": "3b54",
	"./images/index_picture/fc.png": "88b9",
	"./images/iso.jpg": "d9d2",
	"./logo.svg": "9b19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";